<template>
  <div class="activitys px-[27px]">
    <!-- Loading状态 -->
    <div v-if="isPageLoading" class="page-loading-container">
      <van-loading type="spinner" color="#17B663" size="24px" />
    </div>

    <!-- 活动列表 - 只在图片加载完成后显示 -->
    <div v-show="!isPageLoading">
      <div class="activityslist relative mb-[8px] p-[2px] box-border" @click="goActivity(item)"
        v-for="item in activityLists" :key="item.id" v-show="item.appShow !== false">
        <div class="activityslist-bg absolute top-0 left-0 w-full h-full z-2"></div>
        <div class="huodogn relative z-1">
          <div class="img-container" :class="{ 'lens-effect': shouldShowLensEffect(item) }">
            <div class="img-wrapper">
              <img :src="getActivityImage(item.img, locale)" alt="" loading="lazy" @load="onImageLoad"
                @error="onImageError" />
              <!-- 滑动蒙层 -->
              <div v-if="shouldShowLensEffect(item)" class="slide-mask">
              </div>
            </div>
          </div>
        </div>
        <RedDot v-if="shouldShowLensEffect(item)" :big="true" class="absolute top-[5px] right-[5px] z-20" />
        <!-- <div v-if="shouldShowLensEffect(item)"
          class="absolute top-0px right-0px z-20 w-[26px] h-[26px] transform -translate-y-1/4 translate-x-1/4">
          <div class="relative w-full h-full text-white text-white text-[8px] flex items-center justify-center">
            <img :src="getAssetsFile('home/messageUnreadIcon.png')" alt=""
              class=" absolute left-0 top-1px w-full h-[calc(100%+2px)]" />
          </div>
        </div> -->
        <!-- <div class="red-dot" v-if="shouldShowLensEffect(item)"></div> -->
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { RedDot } from "@/components/RedDot";
import * as GameApi from "@/api/game";
import { useRouter, useRoute } from 'vue-router';
import useUIStore from '@/stores/modules/ui';
import { useActivityStore } from '@/stores/modules/activity';
import { useUserStore } from '@/stores/modules/user';
import { parseMultilingualImageData } from '@/utils/multilingual-images';
import { orderBy } from "lodash-es";
import {
  trackPromotionClickTreasureInvite,
  trackPromotionClickWheel,
  trackPromotionClickVip,
  trackPromotionClickAffiliate,
  trackPromotionClickRebate,
  trackPromotionClickRedEnvelope,
  trackPromotionClickDailyRescue,
  trackPromotionClickWeeklyRescue
} from '@/utils/firebase-analytics';
import { ref, onMounted, watch, nextTick, onActivated } from 'vue'
import { useI18n } from 'vue-i18n'
const router = useRouter();
const route = useRoute();
const uiStore = useUIStore();
const activityStore = useActivityStore();
const userStore = useUserStore();
const { locale } = useI18n();
const VITE_IMG_URL = import.meta.env.VITE_IMG_URL;

// 图片资源

// 活动列表
const activityLists = ref([

]);

// 页面加载状态
const isPageLoading = ref(true)
// 红点数据加载状态
const isBadgeDataLoading = ref(true)

// 存储相关
const bankruptcyFlag = useStorage<boolean>("bankruptcyFlag", false, sessionStorage);
const firstRechargeTimerValue = useStorage<number | string | Date | null>(
  "firstRechargeTimerValue",
  null
);

// 转盘次数
const turntableCount = ref(0);
// 宝箱可领取数量
const chestCount = ref(0);
// 神秘抽奖可领取数量
const mysteriousLotteryCount = ref(0);
// 日返水可领取状态
const dailyCashbackClaimable = ref(false);
// 周返水可领取状态
const weekCashbackClaimable = ref(false);

// 更新Eventos红点状态
const updateEventosBadge = () => {
  const hasBadge = turntableCount.value > 0
  uiStore.setActivityBadge('eventos', hasBadge)
}

// 更新宝箱红点状态
const updateChestBadge = () => {
  const hasBadge = chestCount.value > 0
  uiStore.setActivityBadge('chest', hasBadge)
}

// 更新神秘抽奖红点状态
const updateMysteriousLotteryBadge = () => {
  const hasBadge = mysteriousLotteryCount.value > 0
  uiStore.setActivityBadge('mysterious', hasBadge)
}

// 更新日返水红点状态
const updateDailyCashbackBadge = () => {
  const hasBadge = dailyCashbackClaimable.value
  uiStore.setActivityBadge('dailyCashback', hasBadge)
}

// 更新周返水红点状态
const updateWeekCashbackBadge = () => {
  const hasBadge = weekCashbackClaimable.value
  uiStore.setActivityBadge('weekCashback', hasBadge)
}

// 判断是否应该显示镜头特效和红点
const shouldShowLensEffect = (item) => {
  // 如果红点数据还在加载中，不显示红点
  if (isBadgeDataLoading.value) {
    return false;
  }

  // 转盘活动：ID为10且不是自定义类型
  if (item.id === 10 && item.type !== "自定义" && turntableCount.value > 0) {
    return true;
  }

  // 宝箱活动：ID为22且不是自定义类型
  if (item.id === 22 && item.type !== "自定义" && chestCount.value > 0) {
    return true;
  }

  // 神秘抽奖活动：ID为23且不是自定义类型
  if (item.id === 23 && item.type !== "自定义" && mysteriousLotteryCount.value > 0) {
    return true;
  }


  // 日返水活动：ID为12且不是自定义类型
  if (item.id === 12 && item.type !== "自定义" && dailyCashbackClaimable.value) {
    return true;
  }

  // 周返水活动：ID为13且不是自定义类型
  if (item.id === 13 && item.type !== "自定义" && weekCashbackClaimable.value) {
    return true;
  }

  return false;
};

// 获取活动图片 - 支持多语言
const getActivityImage = (imgData: string, currentLocale = locale.value) => {
  // 如果是JSON格式的多语言图片数据
  if (typeof imgData === 'string' && (imgData.startsWith('{') || imgData.includes("en"))) {
    const parsedImage = parseMultilingualImageData(imgData, currentLocale)
    // 如果解析出的图片路径不是完整URL，需要拼接VITE_IMG_URL
    if (parsedImage && !parsedImage.startsWith('http')) {
      return VITE_IMG_URL + parsedImage
    }
    return parsedImage
  }

  // 如果是普通图片路径，直接返回
  return imgData
}
const goMysteriousLottery = () => {
  router.push('/activity/components/MysteriousLottery')
}

// 图片加载事件处理
const onImageLoad = (event) => {
  // 图片加载成功，可以添加淡入效果
  event.target.style.opacity = '1'
}

const onImageError = (event) => {
  // 图片加载失败，可以显示占位图
  console.warn('活动图片加载失败:', event.target.src)
  event.target.style.opacity = '0.5'
}


// 预加载活动图片 - 优化版本
const preloadActivityImages = async (activities) => {
  const currentLocale = locale.value
  const imagePromises = activities.map(activity => {
    return new Promise((resolve) => {
      const img = new Image()
      const timeout = setTimeout(() => {
        resolve(false) // 超时也认为加载完成，避免阻塞
      }, 3000) // 3秒超时

      img.onload = () => {
        clearTimeout(timeout)
        resolve(true)
      }
      img.onerror = () => {
        clearTimeout(timeout)
        resolve(false)
      }
      img.src = getActivityImage(activity.img, currentLocale)
    })
  })

  // 等待所有图片加载完成
  await Promise.all(imagePromises)
  console.log('活动图片预加载完成')
}

// 缓存相关常量
const ACTIVITY_LIST_CACHE_KEY = 'activity_list_cache'
const CACHE_EXPIRE_TIME = 5 * 60 * 1000 // 5分钟缓存时间

// 获取缓存的活动列表
const getCachedActivityList = () => {
  try {
    const cached = localStorage.getItem(ACTIVITY_LIST_CACHE_KEY)
    if (!cached) return null

    const { data, timestamp } = JSON.parse(cached)
    const now = Date.now()

    // 检查缓存是否过期
    if (now - timestamp > CACHE_EXPIRE_TIME) {
      localStorage.removeItem(ACTIVITY_LIST_CACHE_KEY)
      return null
    }

    return data
  } catch (error) {
    console.error('读取活动列表缓存失败:', error)
    return null
  }
}

// 保存活动列表到缓存
const saveActivityListToCache = (data: any[]) => {
  try {
    const cacheData = {
      data,
      timestamp: Date.now()
    }
    localStorage.setItem(ACTIVITY_LIST_CACHE_KEY, JSON.stringify(cacheData))
  } catch (error) {
    console.error('保存活动列表缓存失败:', error)
  }
}

// 清除活动列表缓存
const clearActivityListCache = () => {
  try {
    localStorage.removeItem(ACTIVITY_LIST_CACHE_KEY)
    console.log('活动列表缓存已清除')
  } catch (error) {
    console.error('清除活动列表缓存失败:', error)
  }
}

// 处理活动列表数据
const processActivityListData = (data: any[]) => {
  return orderBy(data, ['sort', 'id'], ['desc', 'desc']).map(item => ({
    ...item,
    nametype: false,
    editData: {
      cn: '',
      en: ''
    }
  }))
}

// 获取活动列表
const getActivityList = async () => {
  // 先尝试从缓存读取
  const cachedData = getCachedActivityList()
  if (cachedData) {
    // 使用缓存数据立即显示
    const sortedActivities = processActivityListData(cachedData)
    activityLists.value = sortedActivities
    // 立即停止loading，不等待图片加载
    isPageLoading.value = false
    console.log('使用缓存的活动列表数据')
    
    // 后台预加载图片（不阻塞UI）
    preloadActivityImages(sortedActivities).then(() => {
      console.log('图片预加载完成')
    })
  } else {
    // 没有缓存，显示loading
    isPageLoading.value = true
  }

  // 只在用户已登录时获取红点数据
  let badgePromises = Promise.resolve()
  if (userStore.isLoggedIn) {
    // 并行执行：获取红点数据（不缓存，每次都请求）
    badgePromises = Promise.allSettled([
      fetchTurntableCount(),
      fetchChestCount(),
      fetchMysteriousLotteryCount(),
      fetchDailyCashbackStatus(),
      fetchWeekCashbackStatus()
    ])
  } else {
    // 未登录时，直接标记红点数据加载完成（不显示红点）
    isBadgeDataLoading.value = false
  }

  // 后台请求最新的活动列表（即使有缓存也要更新）
  const fetchLatestActivityList = async () => {
    try {
      const res = await GameApi.activityList()
      const sortedActivities = processActivityListData(res.data)

      // 更新活动列表
      activityLists.value = sortedActivities
      // 保存到缓存
      saveActivityListToCache(res.data)
      // 立即停止loading，不等待图片加载
      isPageLoading.value = false

      // 后台预加载图片（不阻塞UI）
      preloadActivityImages(sortedActivities).then(() => {
        console.log('图片预加载完成')
      })
    } catch (error) {
      console.error('获取活动列表失败:', error)
      // 如果请求失败且有缓存，继续使用缓存
      if (!cachedData) {
        // 没有缓存且请求失败，停止loading
        isPageLoading.value = false
      }
    }
  }

  // 等待红点数据加载完成（如果已登录）
  await badgePromises
  // 红点数据加载完成
  if (userStore.isLoggedIn) {
    isBadgeDataLoading.value = false
  }

  // 如果有缓存，后台更新；如果没有缓存，等待请求完成
  if (cachedData) {
    // 有缓存时，后台静默更新
    fetchLatestActivityList()
  } else {
    // 没有缓存时，等待请求完成
    await fetchLatestActivityList()
  }
};

// 显示条件判断
const getShow = (item) => {
  if (item.id === 3) {
    return bankruptcyFlag.value;
  }
  if (item.id === 4) {
    return firstRechargeTimerValue.value;
  }
  return true;
};

// 获取转盘次数的函数
const fetchTurntableCount = async () => {
  try {
    await activityStore.getBasicFinancialData();
    turntableCount.value = activityStore.turntableCount;
    // 更新Eventos红点状态
    updateEventosBadge()
  } catch (error) {
    turntableCount.value = 0;
    updateEventosBadge()
  }
};

// 获取宝箱可领取数量的函数
const fetchChestCount = async () => {
  try {
    const params = {
      page: 1,
      pageSize: 100
    }
    const res = await GameApi.getPromoterBox(params)

    if (res && res.data && res.data.list) {
      // 统计状态为1（可领取）的宝箱数量
      chestCount.value = res.data.list.filter(chest => chest.status === 1).length
    } else {
      chestCount.value = 0
    }
    // 更新宝箱红点状态
    updateChestBadge()
  } catch (error) {
    console.error('获取宝箱数据失败:', error)
    chestCount.value = 0
    updateChestBadge()
  }
};

// 获取神秘抽奖可领取数量的函数
const fetchMysteriousLotteryCount = async () => {
  try {
    const res = await GameApi.getMysteriousGoldActivity()

    if (res && res.data && res.data.appDayConfigs) {
      // 统计可领取的天数数量（claimReward为true的天数）
      mysteriousLotteryCount.value = res.data.appDayConfigs.filter(day => day.claimReward === true).length
    } else {
      mysteriousLotteryCount.value = 0
    }
    // 更新神秘抽奖红点状态
    updateMysteriousLotteryBadge()
  } catch (error) {
    console.error('获取神秘抽奖数据失败:', error)
    mysteriousLotteryCount.value = 0
    updateMysteriousLotteryBadge()
  }
};

// 获取日返水可领取状态的函数
const fetchDailyCashbackStatus = async () => {
  try {
    const res = await GameApi.getUserRescue(12)

    if (res && res.data) {
      // 检查是否可以领取（claimed为true即可）
      dailyCashbackClaimable.value = res.data.claimed === true
    } else {
      dailyCashbackClaimable.value = false
    }
    // 更新日返水红点状态
    updateDailyCashbackBadge()
  } catch (error) {
    console.error('获取日返水数据失败:', error)
    dailyCashbackClaimable.value = false
    updateDailyCashbackBadge()
  }
};

// 获取周返水可领取状态的函数
const fetchWeekCashbackStatus = async () => {
  try {
    const res = await GameApi.getUserRescue(13)

    if (res && res.data) {
      // 检查是否可以领取（claimed为true即可）
      weekCashbackClaimable.value = res.data.claimed === true
    } else {
      weekCashbackClaimable.value = false
    }
    // 更新周返水红点状态
    updateWeekCashbackBadge()
  } catch (error) {
    console.error('获取周返水数据失败:', error)
    weekCashbackClaimable.value = false
    updateWeekCashbackBadge()
  }
};

// 跳转活动页面
const goActivity = (item) => {
  console.log('goActivity', item)
  // 先判断type，如果是自定义类型
  if (item.type === "自定义") {
    // 自定义活动也要判断是否有外部链接
    if (item.url !== null && item.url !== '') {
      // 判断是否是外部链接（http开头）
      if (item.url.startsWith('http')) {
        window.open(item.url, '_blank')
      } else {
        // 不是http开头，当作内部路由处理
        router.push(item.url)
      }
      return;
    }
    // 没有外部链接才跳转到自定义详情页
    router.push({
      path: '/activity/components/activityIndex/Custom',
      query: {
        info: item.info,
        name: item.name
      }
    })
    return;
  }

  // 非自定义活动：先判断外部链接
  if (item.url !== null && item.url !== '') {
    // 判断是否是外部链接（http开头）
    if (item.url.startsWith('http')) {
      window.open(item.url, '_blank')
    } else {
      // 不是http开头，当作内部路由处理
      router.push(item.url)
    }
    return;
  }

  // 根据id判断跳转路由（非自定义活动）
  switch (item.id) {
    case 12:
      trackPromotionClickDailyRescue()
      router.push('/activity/components/activityIndex/dailyCashback')
      break;
    case 22:
      trackPromotionClickTreasureInvite()
      router.push('/activity/components/activityIndex/indiqueAmigos')
      break;
    case 13:
      trackPromotionClickWeeklyRescue()
      router.push('/activity/components/activityIndex/weekCashback')
      break;
    case 10:
      trackPromotionClickWheel()
      router.push('/activity/components/activityIndex/turntable')
      break;
    case 9:
      trackPromotionClickRedEnvelope()
      router.push('/activity/components/activityIndex/Misteriosa')
      break;
    case 21:
      trackPromotionClickAffiliate()
      router.push('/activity/components/activityIndex/ComissaoDe')
      break;
    case 11:
      trackPromotionClickRebate()
      router.push({
        path: '/activity',
        query: {
          tab: 'rebate'
        }
      })
      break;
    case 14:
      trackPromotionClickVip()
      router.push('/activity/components/activityIndex/vipavtivity')
      break;
    case 23:
      goMysteriousLottery()
      break;
    case 24:
      router.push('/activity/components/activityIndex/entrada')
      break;
    case 27:
      router.push('/Deposito')
      break;
    default:
      router.push({
        path: '/activity/components/activityIndex/Custom',
        query: {
          info: item.info,
          name: item.name
        }
      })
  }
}

onMounted(() => {
  // 无论是否登录都获取活动列表（活动列表不需要登录）
  getActivityList();

  // 每次进入页面都滚动到顶部
  nextTick(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }, 100)
  })
});

// 使用 onActivated 监听组件激活（从其他页面返回时）
onActivated(() => {
  console.log('活动列表组件被激活，滚动到顶部')
  // 当组件被激活时（从其他页面返回时）滚动到顶部
  nextTick(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }, 100)
  })
})
</script>
<style scoped lang="scss">
.activitys {
  // margin-top: 8px;
  min-height: 200px;
  /* 确保有足够高度显示loading */
}

/* Loading容器样式 */
.page-loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 100%;
}

.activityslist {

  height: 120px;

  .activityslist-bg {
    background: getPath('activity/activitysBorderBg.png') no-repeat center center;
    background-size: 100% calc(100% + 4px);
    background-position: 0 0px;
  }
}

.huodogn {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  // height: calc(120px - 6px);
  flex-direction: column;
  align-items: center;
}

.img-container {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 11px;
  /* overflow: hidden; */
  /* 注释掉这行 */
}

.img-container img {
  width: 100%;
  height: 100%;
  border-radius: 11px;
  display: block;
  // object-fit: cover;
}

.img-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 11px;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;

  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}


/* 悬停时的额外效果 */
.lens-effect:hover {
  transform: scale(1.01);
}

/* 红色圆点提示 */
.red-dot {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 15px;
  height: 15px;
  background-color: red;
  border-radius: 50%;
  z-index: 20;
  /* 提高 z-index */
  /* animation: pulse 2s infinite; */
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    trans0rm: scale(1.2);
    opacity: 0.9;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.slide-mask {
  position: absolute;
  top: 0;
  left: -200%;
  width: 150%;
  height: 120%;
  /* 从左上到右下的斜梯形光带 */
  clip-path: polygon(0% 0%, 100% 0%, 60% 100%, 0% 100%);
  background: linear-gradient(360deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
  animation: slide-light 5s linear infinite;
  z-index: 10;
  border-radius: 11px;
  /* 添加圆角 */
}

@keyframes slide-light {
  0% {
    left: -150%;
    opacity: 1;
  }

  20% {
    left: 0%;
    /* 滑动完成，只用20%的时间 */
    opacity: 1;
  }

  25% {
    left: 0%;
    opacity: 0;
    /* 蒙层消失 */
  }

  100% {
    left: 0%;
    opacity: 0;
    /* 保持消失状态 */
  }
}
</style>
